module.exports = __webpack_public_path__ + "img/intro_2.87b627c5.png";